import * as React from 'react';
import * as request from 'superagent';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import CronSelectView from '~common/components/cron-select-view';
import PortalUserSubscription from '~common/lib/models/portal-user-subscription';
import  { Stepper,Step, StepLabel } from '@mui/material';
import {Button} from '@mui/material';
import {Paper} from '@mui/material';
import {Grid} from '@mui/material';
import {TextField} from '@mui/material';
import {Typography} from '@mui/material';
import SelectableTable from '~common/components/table/selectable-table';
// import QueryString from 'query-string'
import URLManager from '~common/lib/url-manager';

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	},
	secondaryHeading: {
		//fontSize: theme.typography.pxToRem(15),
		//color: theme.palette.text.secondary
	},
	textField: {
		width: '100%'
	},
	formControl: {
		width: '100%'
	},
	nameControl: {
        width: '100%',
        maxWidth: 500
	},
	switch: {
		marginTop: 5
	},
	buttonBar: {
		textAlign: 'right'
	},
	headerPaper: {
		padding: 30
	},
	subheading: {
		marginBottom: 30
	},
	headerTitle: {},
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		margin: 30,
		paddingTop: 15,
		paddingBottom: 15,
		borderTop: '1px solid #ccc',
		//backgroundColor: theme.palette.background
	},
	paper: {
		paddingLeft: 30,
		paddingRight: 30,
		paddingBottom: 30,
		minHeight: 300
	},
	bodyReview: {
		//color: theme.palette.text
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	location: any;
	match: any;
}

type State = {
	dirty: boolean;
	status: 'ready' | 'loading';
	subscription: PortalUserSubscription;
	error?: any;
	tableData: Array<any>;
	returnURL?: string | string[] | null;
};

class SubscriptionEdit extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			status: 'loading',
			dirty: false,
			subscription: new PortalUserSubscription(),
			tableData: []
		};
	}

	componentDidMount() {

    	const {match} = this.props;

		const returnURL:string = URLManager.getQueryStringValueByKey("returnURL", window.location.href)
	
		PortalUserSubscription.get(match.params.id)
			.then((s) => {
				
				this.setState({ subscription: s }, ()=>{

					var promises: Array<any> = [];

					promises.push(request.get("/api/form-definitions/select?selector="+URLManager.getQueryStringValue(s.extendedAttributes?.value?.criteriaFormSelector)))
					promises.push(request.get("/api/form-definitions/select?selector="+URLManager.getQueryStringValue(s.extendedAttributes?.value?.resultsFormSelector)))

					Promise.all(promises).then((values)=>{

						// fetch data for preview during step 2
						// add limit and skip since we just need some sample data
						var criteria = s.extendedAttributes?.value?.criteria
						criteria.limit = 10
						criteria.skip = 0
						criteria.criteriaForm = values[0].body
						criteria.resultsForm = values[1].body

						request.post(s.dataURL.value || '').send(criteria).then((response) => {
							if (response.ok) {
								if (response.body.items) {
									this.setState({status:"ready", returnURL:returnURL, tableData: response.body.items });
								}
							}
						})
						.catch((err) => {
							this.setState({status:"ready",returnURL:returnURL,  error: err });
						});

					}).catch((err)=>{
						this.setState({status:"ready",returnURL:returnURL,  error: err });
					})					
				});

				
			})
			.catch((err) => {
				this.setState({status:"ready",returnURL:returnURL,  error: err });
			});
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
		//this.props = newProps;
	}
	handleAttributeChange = (attr: any): any => (event: any): void => {
		if (attr.handleChange) {
			attr.handleChange(event);
			this.setState({});
		}
	};

	handleDateAttributeChange = (attr: string): any => (val: any | undefined): void => {};

	getActiveStep = (): number => {

    const {match} = this.props;
		switch (match.params.step) {
			case 'info':
				return 0;

			case 'schedule':
				return 1;

			case 'review':
				return 2;
			
			case 'complete':
				return 3;
				

			default:
				return 0;
		}
	};

	updateQueryStringParameter = (uri:string, key:string, value:string):string => {
    	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    	var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	}

	getSteps = () => {
		return [ 'Provide subcription information', 'Set a schedule', 'Review and save', 'Complete' ];
	};

	getStepContent = (step: number) => {
		const { classes }: { classes: ClassNameMap } = this.props;
		const { subscription, tableData } = this.state;
		const { returnURL } = this.state;
		const sReturnURL = (returnURL || "").toString();

		switch (step) {
			case 0:
				return (
					<Paper className={classes.paper} elevation={0}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								<TextField
									label="Name"
									required
									className={classes.nameControl}
									InputLabelProps={{
										shrink: true
									}}
									margin="normal"
									value={subscription.name.value || ''}
									error={subscription.name.error ? true : false}
									onChange={this.handleAttributeChange(subscription.name)}
									helperText="This is the name of your subscription.  It should be descriptive and unique."
								/>
                                </Grid>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								<TextField
									label="Subject"
									required
									className={classes.nameControl}
									InputLabelProps={{
										shrink: true
									}}
									margin="normal"
									value={subscription.subject.value || ''}
									error={subscription.subject.error ? true : false}
									onChange={this.handleAttributeChange(subscription.subject)}
									helperText="This will be the subject of your email."
								/>
							</Grid>
							<Grid item xs={12} sm={12} md={12} lg={12}>
								<TextField
									label="Body"
									multiline
									required
									rows={5}
									className={classes.formControl}
									InputLabelProps={{
										shrink: true
									}}
									margin="normal"
									value={subscription.template.value || ''}
									error={subscription.template.error ? true : false}
									onChange={this.handleAttributeChange(subscription.template)}
									helperText="This will be used as the body of your email.  Data results of the query will be attached as an excel file."
								/>
							</Grid>
						</Grid>
					</Paper>
				);
			case 1:
				return (
					<Paper className={classes.paper} elevation={0}>
						<CronSelectView
							classes={{}}
							cron={subscription.cron.value}
							onCronChange={this.handleCronChange}
						/>
					</Paper>
				);
			case 2:
				return (
					<Paper className={classes.paper} elevation={0}>
						<Typography variant="h6" gutterBottom>
							Subject
						</Typography>
						<Typography className={classes.subheading} variant="subtitle1" gutterBottom>
							{subscription.subject.value}
						</Typography>
						<Typography variant="h6" gutterBottom>
							Body
						</Typography>
						<Typography component="pre" className={classes.subheading} variant="subtitle1" gutterBottom>
							{subscription.template.value || ''}
						</Typography>
						<Typography variant="h6" gutterBottom>
							Schedule
						</Typography>
						<Typography component="div" className={classes.subheading} variant="subtitle1" gutterBottom>
							<CronSelectView
								readOnly
								classes={{}}
								cron={subscription.cron.value}
								onCronChange={this.handleCronChange}
							/>
						</Typography>
						<Typography variant="h6" gutterBottom>
							Sample Excel Data
						</Typography>
						<SelectableTable
							hideToolbar={true}
							history={history}
							title="Sample Excel Data"
							classes={{}}
							columns={subscription.extendedAttributes.value.columns || []}
							tableData={tableData}
							allowExport={false}
						/>
					</Paper>
				);
			case 3:
				return (
					<Paper className={classes.paper} elevation={0}>
						<Typography style={{textAlign: 'center'}} variant="h6" gutterBottom>
							Your subscription has been created.
						</Typography>
						<Typography style={{textAlign: 'center'}} variant="h6" gutterBottom>
							You can manage your subscriptions <a href="/subscriptions/list">here.</a>
						</Typography>
						<Typography style={{textAlign: 'center'}} variant="h6" gutterBottom>
							Click <a href={sReturnURL || "/"}>here</a> to go back to your source query.
						</Typography>
					</Paper>
				)
			default:
				return 'Unknown step';
		}
	};

	handleCronChange = (cron: string, valid: boolean) => {
		const { subscription } = this.state;
		if (valid) {
			subscription.cron.value = cron;
		} else {
			subscription.cron.value = undefined;
		}
		this.setState({ subscription });
	};

	handleNext = () => {

    	const {match} = this.props;
		const activeStep = this.getActiveStep();
		const { history } = this.props;
		const { subscription, returnURL } = this.state;

    	const sReturnURL = (returnURL || "").toString();

		switch (activeStep) {
			case 0:
				history.push('/subscriptions/' + match.params.id + '/schedule' + window.location.search);
				return;
			case 1:
				history.push('/subscriptions/' + match.params.id + '/review' + window.location.search);
				return;
			case 2:
				// console.log('Save the subscription');
				if (Intl && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions) {
					subscription.extendedAttributes.value.userLocale = Intl.DateTimeFormat().resolvedOptions().timeZone
				}

				if (returnURL) {
					const url = new URL(returnURL);
					subscription.extendedAttributes.value.sourceURL = url.pathname + url.search
				}
				
				this.setState({saving: true}, ()=>{

					var modelData = subscription.getModelData()

					delete modelData.extendedAttributes?.criteria?.criteriaForm
					delete modelData.extendedAttributes?.criteria?.resultsForm
					delete modelData.extendedAttributes?.criteria?.skip
					delete modelData.extendedAttributes?.criteria?.limit

					request.put(`/api/portal-user-subscriptions/${subscription.id}/complete`).send(modelData).then((response: request.Response)=>{
						this.setState({saving: undefined}, ()=>{
							history.push('/subscriptions/' + match.params.id + '/complete' + window.location.search);
						})
					}).catch((err)=>{
						this.setState({saving: undefined, error:err})
					})
				})
				
				return;
			case 3:
				 window.location.href = sReturnURL || "/"
		}
	};

	handleBack = () => {

		const {match} = this.props;
		const activeStep = this.getActiveStep();
		const { history } = this.props;

		switch (activeStep) {
			case 1:
				history.push('/subscriptions/' + match.params.id + '/info' + window.location.search);
				return;
			case 2:
				history.push('/subscriptions/' + match.params.id + '/schedule' + window.location.search);
				return;
		}
	};

    handleErrorClose = () => {
        this.setState({error:undefined})
    }

	getNextButtonText = () => {
		const activeStep = this.getActiveStep();
		switch (activeStep) {
			case 0:
				return "Next"
			case 1:
				return "Next"
			case 2:
				return "Finish"
			case 3: 
				return "OK"
		}
	}

	render() {

		const { classes }: { classes: ClassNameMap } = this.props;
		const { status, subscription, error, saving } = this.state;
		const {match} = this.props;
		const steps = this.getSteps();
		const activeStep = this.getActiveStep();	

		if (status == 'loading') {
			return <LoadingView classes={{}} />;
		}
		var nextDisabled = true;
		switch (activeStep) {
			case 0:
				if (subscription.name.value && subscription.subject.value && subscription.template.value) {
					nextDisabled = false;
				}

				break;
			case 1:
				if (subscription.cron.value) {
					nextDisabled = false;
				}
                break;
            case 2:
			    nextDisabled = false;
			case 3:
				nextDisabled = false;

		}
		if (activeStep == 0) {
			// console.log("hey")
		}
		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
                    {error && <ErrorView classes={{}} onClose={this.handleErrorClose} error={error} />}
					{saving && <LoadingView text={"Saving"} overlay={true} classes={{}} />}
					<Paper elevation={0}>
						<Stepper activeStep={activeStep}>
							{steps.map((label, index) => {
								const props = {};
								const labelProps = {};
								return (
									<Step key={label} {...props}>
										<StepLabel {...labelProps}>{label}</StepLabel>
									</Step>
								);
							})}
						</Stepper>
						<div>
							<div>
								{this.getStepContent(activeStep)}
								{match.params.step != "complete" && <div className={classes.toolbar}>
									<Button
										disabled={activeStep === 0}
										onClick={this.handleBack}
										className={classes.button}
									>
										Back
									</Button>
									<Button
										variant="contained"
										disabled={nextDisabled}
										color="primary"
										onClick={this.handleNext}
										className={classes.button}
									>
										{this.getNextButtonText()}
									</Button>
								</div>}
							</div>
						</div>
					</Paper>
				</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(SubscriptionEdit);
